import { useEffect } from 'react';
import {
  buildSearchWithoutExternalBrowserRedirect,
  getExternalBrowserRedirectSearchValue,
  primeExternalBrowserRedirectIntent,
} from '../lib/external-browser';

const useExternalBrowserRedirectIntent = ({
  isInstagram,
  showExternalBrowserInstructions,
  url,
}) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const hasRedirectIntent = getExternalBrowserRedirectSearchValue(
      window.location.search
    );

    const shouldPrimeIntent = isInstagram && showExternalBrowserInstructions;

    if (shouldPrimeIntent) {
      primeExternalBrowserRedirectIntent(url);
    } else if (hasRedirectIntent) {
      const nextSearch = buildSearchWithoutExternalBrowserRedirect(
        window.location.search
      );
      const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;

      window.history.replaceState(null, '', nextUrl);
    }
  }, [isInstagram, showExternalBrowserInstructions, url]);
};

export default useExternalBrowserRedirectIntent;
